// Articles published on SmartLiving.ro by Oana Tenea
// Auto-generated by scraper

export const smartLivingArticles = [
  {
    "id": "sl-1",
    "title": "De ce rămânem în relații toxice? „Mintea preferă să justifice, nu să renunțe“",
    "excerpt": "De ce multe femei din relații toxice cred că este vina lor? Cum se formează autoînvinovățirea, ce istorii de viață o hrănesc și cum poate fi rupt acest…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2025-01-08",
    "externalUrl": "https://smartliving.ro/de-ce-ramanem-in-relatii-toxice-mintea-prefera-sa-justifice-nu-sa-renunte/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-2",
    "title": "Trauma invizibilă a copilului care crește cu un părinte instabil emoțional. Ce învață să facă pentru a fi iubit",
    "excerpt": "O boală psihică netratată are un impact devastator asupra copiilor",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2025-01-01",
    "externalUrl": "https://smartliving.ro/trauma-invizibila-a-copilului-care-creste-cu-un-parinte-instabil-emotional-ce-invata-sa-faca-pentru-a-fi-iubit/",
    "tags": [
      "Parentaj",
      "Trauma"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-3",
    "title": "Cel mai important test pentru un cuplu: Cum știi dacă ești într-o relație sigură",
    "excerpt": "Pe baza cercetărilor și literaturii recente, iată câteva semne clare că ai parte de siguranță în relație.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-12-25",
    "externalUrl": "https://smartliving.ro/cel-mai-important-test-pentru-un-cuplu-cum-stii-daca-esti-intr-o-relatie-sigura/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-4",
    "title": "Unii copii nu se integrează în colectiv și NU e nevoie să se schimbe. Ce să le spui și ce să eviți",
    "excerpt": "„Ca mamă și ca terapeut, mă întorc deseori la o întrebare simplă, dar puternică.\"",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-12-18",
    "externalUrl": "https://smartliving.ro/unii-copii-nu-se-integreaza-in-colectiv-si-nu-e-nevoie-sa-se-schimbe-ce-sa-le-spui-si-ce-sa-eviti/",
    "tags": [
      "Parentaj"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-5",
    "title": "Prevăzători sau pesimiști? Ce se ascunde în spatele anticipărilor negative",
    "excerpt": "Le numim anticipări negative, iar dacă nu suntem atenți, pot deveni o profeție care se autoîmplinește.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-12-11",
    "externalUrl": "https://smartliving.ro/prevazatori-sau-pesimisti-ce-se-ascunde-in-spatele-anticiparilor-negative/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-6",
    "title": "Epuizarea emoțională: semnale de alarmă și reguli de igienă interioară",
    "excerpt": "Epuizarea emoțională se instalează când atenția noastră este adesea spre ceilalți și deloc spre noi. Iată câteva reguli de igienă emoțională.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-12-04",
    "externalUrl": "https://smartliving.ro/epuizarea-emotionala-semnale-de-alarma-si-reguli-de-igiena-interioara/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-7",
    "title": "Cum e să iubești un perfecționist? „Se putea și mai bine“",
    "excerpt": "Perfecționiștii își stabilesc standarde foarte înalte pentru ei înșiși, dar și pentru partenerul de cuplu.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-11-27",
    "externalUrl": "https://smartliving.ro/cum-e-sa-iubesti-un-perfectionist-se-putea-si-mai-bine/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-8",
    "title": "„Aveam așteptări nerealiste de la copil și de la mine.” 14 tehnici de gestionare a furiei și confesiunile mamelor",
    "excerpt": "Ca mame, este important să ne dăm voie să simțim toate emoțiile, dar să ne amintim că avem controlul asupra modului în care alegem să le exprimăm.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-11-20",
    "externalUrl": "https://smartliving.ro/tehnici-de-gestionare-a-furiei-si-confesiunile-mamelor/",
    "tags": [
      "Emoții"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-9",
    "title": "Opinii diferite: 8 strategii ca să nu ajungi la certuri și să păstrezi relații sănătoase în contextul actual polarizat",
    "excerpt": "Adesea avem opinii diferite, dar acestea nu trebuie să degenereze în conflicte. Cum putem preveni acest lucru?",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-11-13",
    "externalUrl": "https://smartliving.ro/8-strategii-pentru-conversatii-in-care-avem-opinii-diferite/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-10",
    "title": "„10 motive pentru care oamenii se subestimează de obicei, din experiența mea de psiholog“",
    "excerpt": "Acea voce interioară care ne spune dacă suntem suficient de buni, capabili sau valoroși – aceasta este stima de sine și, pentru unii dintre noi, este foarte fragilă.",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-11-06",
    "externalUrl": "https://smartliving.ro/10-motive-pentru-care-oamenii-se-subestimeaza-de-obicei-din-experienta-mea-de-psiholog/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-11",
    "title": "8 tipuri de despărțiri: ce spun despre noi și ce învățăm din ele",
    "excerpt": "Fiecare despărțire poate fi o oportunitate de creștere personală.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-10-30",
    "externalUrl": "https://smartliving.ro/tipuri-de-despartiri-si-ce-invatam-din-ele/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-12",
    "title": "Cum să-ți redescoperi copilul interior ca să-ți vindeci rănile emoționale și să regăsești bucuria autentică",
    "excerpt": "Experiențele dureroase din copilărie tind să ne însoțească și la maturitate, astfel încât ne putem simți „blocați” emoțional și uităm să ne bucurăm pur și simplu de viață.",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-10-22",
    "externalUrl": "https://smartliving.ro/copil-interior-cum-il-redescoperi-rani-emotionale-bucuria-autentica/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-13",
    "title": "Creierul nostru urăște alți oameni? „Noi“ versus „ei“: de ce ne place să împărțim lumea în două",
    "excerpt": "Diviziunea între noi și ei înseamnă prejudecăți și lipsă de empatie. Iată cum gestionăm corect perceperea diferențelor dintre noi și ceilalți.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-10-15",
    "externalUrl": "https://smartliving.ro/diviziunea-intre-noi-si-ei-de-ce-ne-place-sa-impartim-lumea-in-doua/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-14",
    "title": "Diferența între a avea nevoie și a iubi: Cum să recunoști dinamica emoțională în relația ta de cuplu",
    "excerpt": "Deseori, cuplurile se confruntă cu dificultăți nu pentru că nu există iubire, ci pentru că iubirea lor este eclipsată de nevoi nesatisfăcute.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-10-08",
    "externalUrl": "https://smartliving.ro/diferenta-intre-a-avea-nevoie-si-a-iubi-cum-sa-recunosti-dinamica-emotionala-in-relatia-ta-de-cuplu/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-15",
    "title": "Disocierea te ajută să faci față stresului și oboselii. Când este o problemă",
    "excerpt": "Disocierea este un mecanism de protecție util atunci când traversăm perioade solicitante. Când devine o problemă?",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-10-01",
    "externalUrl": "https://smartliving.ro/disocierea-te-ajuta-sa-faci-fata-stresului-si-oboselii-cand-este-o-problema/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-16",
    "title": "„11 calități esențiale pe care le-am observat la cuplurile care rezistă în timp, din rolul de psiholog”",
    "excerpt": "Ne dorim relații de durată, dar adesea nu cultivăm în noi comportamente necesare unui cuplu. Iată câteva calități esențiale ale relațiilor longevive.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-09-24",
    "externalUrl": "https://smartliving.ro/cuplurile-care-rezista-in-timp-11-calitati-esentiale/",
    "tags": [
      "Relații",
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-17",
    "title": "De ce mai ales bărbații au un comportament defensiv în cuplu și sfaturi pentru a gestiona situația",
    "excerpt": "Iată de ce mai frecvent bărbații au un comportament defensiv în cuplu și ce putem face.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-09-17",
    "externalUrl": "https://smartliving.ro/comportamentul-defensiv-in-cuplu-cum-apare/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-18",
    "title": "10 moduri prin care cuplurile îi fac pe prietenii lor single să se simtă excluși",
    "excerpt": "De la „Nu cred că te-ai simți bine cu noi în vacanță” la „Ești tu prea pretențios, de aceea ești singur”.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-09-10",
    "externalUrl": "https://smartliving.ro/single-10-moduri-prin-care-cuplurile-ii-fac-pe-prietenii-singuri-sa-se-simta-exclusi/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-19",
    "title": "60% din femei se simt nesigure pe ele în viața personală, profesională și în relații. 10 sfaturi să depășim nesiguranța",
    "excerpt": "Nesiguranțele noastre conturează modul în care vom relaționa cu noi înșine, cu ceilalți, la locul de muncă sau în viața personală. Cum ne ocupăm de ele?",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-09-03",
    "externalUrl": "https://smartliving.ro/nesiguranta-ce-o-alimenteaza-10-sfaturi/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-20",
    "title": "Ce ascunde nevoia de control și cum gestionăm o astfel de problemă",
    "excerpt": "Să cultivi nevoia de control înseamnă să te lași dominat de comportamente nesănătoase, nefaste atât ție cât și relațiilor tale.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-08-27",
    "externalUrl": "https://smartliving.ro/ce-spune-despre-noi-nevoia-de-control/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-21",
    "title": "Operațiile estetice cresc stima de sine. Sau nu?",
    "excerpt": "Majoritatea dintre noi avem un anumit grad de dismorfie corporală. Cu toții ne putem recunoaște într-un dialog interior depreciativ: „Arăt gras”, „Nasul meu este prea mare”, „Părul mi…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-08-20",
    "externalUrl": "https://smartliving.ro/operatiile-estetice-cresc-stima-de-sine-sau-nu/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-22",
    "title": "Criza vârstei mijlocii: cum întorci timpul în favoarea ta",
    "excerpt": "Nu poți întoarce timpul, dar îl poți face să treacă cu mai mult sens. Psihologul Oana Tenea are 6 exemple.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-08-13",
    "externalUrl": "https://smartliving.ro/criza-varstei-mijlocii-cum-vezi-timpul-la-jumatatea-vietii-si-cum-sa-l-intorci-in-favoarea-ta/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-23",
    "title": "De ce este importantă autonomia în cuplu: 10 beneficii",
    "excerpt": "Cultivând autonomia în cuplu învățăm să îl acceptăm și iubim pe celălalt fiind liberi și oferind libertate. Autonomia ține cont atât de nevoile celuilalt, cât și de ale…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-08-06",
    "externalUrl": "https://smartliving.ro/autonomia-in-cuplu-de-ce-este-importanta/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-24",
    "title": "Generozitatea este benefică, dar are și laturi întunecate. Întrebări pe care să ți le pui când vrei să fii generos",
    "excerpt": "Generozitatea este un comportament dezirabil cât timp nu reprezintă o obligație și ține cont de resursele noastre.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-07-30",
    "externalUrl": "https://smartliving.ro/generozitatea-este-benefica-dar-are-si-laturi-intunecate/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-25",
    "title": "5 pași importanți pentru a putea avea încredere în sentimentele noastre",
    "excerpt": "Să avem încredere în sentimentele noastre înseamnă să ne cunoaștem foarte bine nevoile din spatele lor. Uneori, putem acționa necugetat conduși de emoții.",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-07-23",
    "externalUrl": "https://smartliving.ro/incredere-in-sentimentele-noastre-pasi-importanti/",
    "tags": [
      "Emoții",
      "Încredere"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-26",
    "title": "„Nu am vorbit cu tata timp de 8 ani!” De ce apare învinovățirea părintelui după divorț",
    "excerpt": "Copiii care apelează la învinovățirea părintelui după divorț au această reacție când sunt prinși în conflictul dintre cei doi părinți sau folosiți ca arme împotriva unuia. Iată cum…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-07-16",
    "externalUrl": "https://smartliving.ro/invinovatirea-parintelui-dupa-divort-de-ce-apare-ce-avem-de-facut/",
    "tags": [
      "Parentaj",
      "Parentaj"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-27",
    "title": "Cer oare relațiile prea multă muncă? De ce unii bărbați rămân singuri?",
    "excerpt": "Să fii singur este oare mai bine decât să fii într-o relație? Oare oamenii care aleg să nu fie într-un cuplu, sunt toți traumatizați relațional? De ce bărbații…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-07-09",
    "externalUrl": "https://smartliving.ro/barbatii-singuri-cer-oare-relatiile-multa-munca/",
    "tags": [
      "Relații",
      "Cuplu",
      "Trauma"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-28",
    "title": "Etapele dezvoltării unei relații: ce ajută două persoane să formeze un cuplu și cât contează chimia romantică?",
    "excerpt": "În etapele dezvoltării unei relații, o importanță majoră o are intimitatea emoțională, respectiv construirea unui mediu în care ne simțim în siguranță și să fim noi înșine.",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-07-02",
    "externalUrl": "https://smartliving.ro/etapele-dezvoltarii-unei-relatii-ce-ajuta-doua-persoane-sa-formeze-un-cuplu-si-cat-conteaza-chimia-romantica/",
    "tags": [
      "Relații",
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-29",
    "title": "Când este sănătoasă nevoia de validare și când devine o problemă",
    "excerpt": "Nevoia de validare este firească și o manifestăm încă din copilărie când căutăm aprobarea și încurajarea părinților. Adesea însă, la maturitate, nu am interiorizat validarea, căutând-o excesiv în…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-06-25",
    "externalUrl": "https://smartliving.ro/cand-este-sanatoasa-nevoia-de-validare-si-cand-devine-o-problema/",
    "tags": [
      "Parentaj"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-30",
    "title": "„Psihopații pot părea normali, chiar fermecători.” Semnele care trădează un psihopat",
    "excerpt": "Psihopatia nu este chiar atât de rar întâlnită cum ne-am aștepta, dar dacă factorii genetici joacă un rol important în predispunerea unei persoane către această tulburare, la un…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-06-18",
    "externalUrl": "https://smartliving.ro/psihopatia-nu-este-chiar-o-raritate-care-sunt-trasaturile-unui-psihopat/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-31",
    "title": "„Oare flirtează cu mine?” Ce este de fapt flirtul și ce rol are acest comportament?",
    "excerpt": "Fiecare avem un stil propriu de a flirta cu ceilalți și o facem în anumite condiții, uneori cu un anumit scop. Ce este și ce nu este flirtul?",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-06-11",
    "externalUrl": "https://smartliving.ro/flirtul-ce-este-de-fapt-si-ce-rol-are/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-32",
    "title": "De ce simțim invidie și care este rolul ei?",
    "excerpt": "Când simțim invidie trecem prin durere emoțională, orientată către ceea ce nu avem. Remediul poate fi recunoștința și renunțarea la comparații, dar iată și alte câteva explicații și…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-06-04",
    "externalUrl": "https://smartliving.ro/invidie-de-ce-o-simtim-si-care-este-rolul-ei/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-33",
    "title": "Ce înseamnă sociopat? 11 semne care trădează această tulburare",
    "excerpt": "Un sociopat nu va ține cont de sentimentele celorlalți și se va angaja adesea în activități riscante. Consideră că regulile nu i se aplică și nu diferențiază între…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-05-28",
    "externalUrl": "https://smartliving.ro/sociopat-semnele-care-tradeaza-aceasta-tulburare/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-34",
    "title": "Chiar dacă ai avut o copilărie nefericită, poți fi un adult împlinit! Cum ajută atașamentul securizant",
    "excerpt": "Ne putem dezvolta la maturitate un atașament securizant, chiar dacă relațiile din copilărie ne-au creat un fond anxios. Iată câteva lucruri pe care le putem face pentru a…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-05-21",
    "externalUrl": "https://smartliving.ro/atasamentul-securizant-chiar-daca-ai-avut-o-copilarie-nefericita-poti-fi-un-adult-implinit/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-35",
    "title": "„Orgoliul e important pentru cineva guvernat de frici, care nu se simte suficient de bun”. Ce este de fapt orgoliul și când devine nesănătos",
    "excerpt": "Ce înseamnă orgoliu și ce rol joacă în relațiile noastre? El este partea nesănătoasă a ego-ului și ascunde multă frică. Iată cum îl identificăm și corectăm.",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-05-14",
    "externalUrl": "https://smartliving.ro/orgoliul-ce-inseamna-si-cand-devine-nesanatos/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-36",
    "title": "Ce apreciază cel mai mult femeile la un bărbat: independența emoțională, în top 10",
    "excerpt": "Un mic ghid pentru bărbații care vor să știe care sunt acele calități masculine atrăgătoare pentru femei. Multe dintre ele au legătură cu sănătatea emoțională!",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-05-07",
    "externalUrl": "https://smartliving.ro/calitati-masculine-atragatoare-pentru-femei-10-cele-mai-importante/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-37",
    "title": "Ce apreciază un bărbat la o femeie? Iată 12 trăsături identificate de psihologi",
    "excerpt": "Ce apreciază un bărbat la o femeie nu se limitează la fizic ci ține de comportamentul ei, umor, încredere în sine, abilitatea de a fi autonomă. Iată și…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-04-30",
    "externalUrl": "https://smartliving.ro/ce-apreciaza-un-barbat-la-o-femeie-iata-12-trasaturi-identificate-de-psihologi/",
    "tags": [
      "Încredere"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-38",
    "title": "Toată viața este o negociere, dar care sunt tehnicile cele mai potrivite?",
    "excerpt": "Când avem de purtat o negociere este recomandat să fim cât mai autentici și să evităm manipularea. Altfel, șansele de a obține ceea ce ne dorim, scad.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-04-23",
    "externalUrl": "https://smartliving.ro/negociere-care-sunt-tehnicile-potrivite/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-39",
    "title": "„Creierul îmi spune să ies din relația toxică, dar mă tem că nu voi găsi ceva mai bun”. De ce sunt femeile atrase de băieți răi",
    "excerpt": "Indisponibili emoțional, toxici, rebeli, instabili și totuși, de ce sunt femeile atrase de băieți răi? Iată câteva explicații.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-04-16",
    "externalUrl": "https://smartliving.ro/de-ce-femeile-sunt-atrase-de-baieti-rai-sfaturi-de-la-psiholog/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-40",
    "title": "Râsul are un efect similar cu antidepresivele! De ce râd femeile mai mult decât bărbații",
    "excerpt": "Beneficiile râsului sunt numeroase, el funcționând precum un antidepresiv natural si facilitând conectarea socială. Iată câteva motive pentru a ne permite să râdem mai des.",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-04-09",
    "externalUrl": "https://smartliving.ro/beneficiile-rasului-asupra-sanatatii-fizice-si-mentale/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-41",
    "title": "Care sunt cele mai frecvente complexe și cum luptăm cu ele",
    "excerpt": "De ce avem complexe și cum apar? Iată cele mai frecvente complexe masculine și feminine, dar și cum învățăm să le corectăm.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-04-02",
    "externalUrl": "https://smartliving.ro/ce-sunt-complexele-care-sunt-cele-mai-frecvente-la-femei-si-la-barbati/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-42",
    "title": "Cum rezolvăm în cuplu diferențe de comunicare între femei și bărbați",
    "excerpt": "Multe diferențe de comunicare între femei și bărbați țin de diferențele educaționale, dar și de predispozițiile cu care ne naștem. O relație de cuplu sănătoasă înseamnă să învățăm…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-03-27",
    "externalUrl": "https://smartliving.ro/diferente-de-comunicare-intre-femei-si-barbati-cum-le-rezolvam/",
    "tags": [
      "Cuplu",
      "Comunicare"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-43",
    "title": "Abuzul emoțional asupra copilului și efectele lui la vârsta adultă. Patru posibile consecințe",
    "excerpt": "Deși deseori trece drept „educație”, abuzul emoțional asupra copilului este o agresiune asupa celui mic, efectele acestui comportament afectându-l și la maturitate. Iată de ce este important să…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-03-20",
    "externalUrl": "https://smartliving.ro/abuzul-emotional-asupra-copilului-si-efectele-lui-la-varsta-adulta-patru-posibile-consecinte/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-44",
    "title": "Iubirea de sine este esențială pentru o viață împlinită. Soluții de aplicat zi de zi",
    "excerpt": "Este necesar să înveți cum să te iubești pe tine ca să poți oferi iubire celor din jur. Iată câteva acțiuni concrete pentru sănătatea ta emoțională.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-03-13",
    "externalUrl": "https://smartliving.ro/iubirea-de-sine-este-esentiala-pentru-o-viata-implinita/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-45",
    "title": "7 motive din spatele unor probleme cu memoria",
    "excerpt": "În timp ce anumite probleme cu memoria reprezintă semnale de alarmă, altele depind de stări interioare care necesită atenția noastră.",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-03-06",
    "externalUrl": "https://smartliving.ro/motive-din-spatele-unor-probleme-cu-memoria/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-46",
    "title": "„Soții care rămân fideli unul altuia ar trebui să se simtă mândri de vitejia lor”. Cât de capabili suntem să mai susținem monogamia",
    "excerpt": "Suntem mai deschiși în privința sexualității, dar intransigenți cu fidelitatea sexuală. Monogamia este un deziderat destul de dificil de susținut.",
    "category": "Relații",
    "readingTime": 3,
    "publishDate": "2024-02-28",
    "externalUrl": "https://smartliving.ro/ce-este-monogamia-si-cat-de-capabili-suntem-sa-o-sustinem/",
    "tags": [
      "Relații"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-47",
    "title": "Recunoștința este pastila magică pentru starea de bine. 3 tehnici recomandate de psiholog",
    "excerpt": "Avem nevoie de recunoștință pentru a ne reaminti de lucrurile pe care odată ni le-am dorit, iar acum le avem. Ea ne antrenează creierul să vadă și partea…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-02-21",
    "externalUrl": "https://smartliving.ro/recunostinta-pastila-magica-pentru-starea-de-bine/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-48",
    "title": "10 comportamente de evitat după o despărțire",
    "excerpt": "Tristețea, suferința, sentimentul de gol ce apar la încheierea unei relații, ne pot împinge către acțiuni ce ne pot împiedica vindecarea. Iată câteva comportamente de evitat după o…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-02-14",
    "externalUrl": "https://smartliving.ro/comportamente-de-evitat-dupa-o-despartire-zece-recomandari/",
    "tags": [
      "Relații",
      "Vindecare"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-49",
    "title": "Abuzul emoțional în cuplu, ce manifestări are și cum îi pui capăt",
    "excerpt": "Abuzul emoțional lasă urme la fel de adânci ca orice altă agresiune. Este important să îl identificăm, să nu luăm vina asupra noastră și să cerem ajutor.",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-02-07",
    "externalUrl": "https://smartliving.ro/abuzul-emotional-in-cuplu-ce-manifestari-are/",
    "tags": [
      "Cuplu"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-50",
    "title": "Cum protejăm copilul într-un divorț. „Ideal este să fie prezenți ambii părinți când anunță decizia”",
    "excerpt": "La divorț, brusc, un părinte pleacă, ambii părinți sunt tulburați emoțional, iar copilul se simte responsabil sau, mai rău, vinovat. Din acest motiv, este necesar să știm cum…",
    "category": "Relații",
    "readingTime": 4,
    "publishDate": "2024-01-31",
    "externalUrl": "https://smartliving.ro/cum-protejam-copilul-la-divort-sfaturile-psihologului/",
    "tags": [
      "Parentaj"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-51",
    "title": "De ce nu trebuie să ne „vindecăm” de emotivitate și rolul major pe care îl au relațiile din copilărie",
    "excerpt": "În loc să fugim de emotivitate, să o ascundem și să încercăm să o reparăm, putem să înțelegem ce ne transmit emoțiile noastre, unde avem nevoie de vindecare…",
    "category": "Sănătate emoțională",
    "readingTime": 4,
    "publishDate": "2024-01-24",
    "externalUrl": "https://smartliving.ro/de-ce-nu-trebuie-sa-ne-vindecam-de-emotivitate/",
    "tags": [
      "Relații",
      "Emoții",
      "Vindecare"
    ],
    "source": "SmartLiving.ro"
  },
  {
    "id": "sl-52",
    "title": "Frica nesănătoasă și efectele ei. Ce facem când pericolele există doar în mintea noastră",
    "excerpt": "Frica ne este utilă, dar ce facem când nu are o cauză reală în exterior, când pericolul există doar în mintea noastră sau când frica se transformă în…",
    "category": "Sănătate emoțională",
    "readingTime": 3,
    "publishDate": "2024-01-17",
    "externalUrl": "https://smartliving.ro/frica-nesanatoasa-si-efectele-ei/",
    "tags": [
      "Sănătate emoțională"
    ],
    "source": "SmartLiving.ro"
  }
];

// Working hours
export const workingHours = {
  schedule: {
    monday: { start: '09:00', end: '18:00', available: true },
    tuesday: { start: '09:00', end: '18:00', available: true },
    wednesday: { start: '09:00', end: '18:00', available: true },
    thursday: { start: '09:00', end: '18:00', available: true },
    friday: { start: '', end: '', available: false },
    saturday: { start: '', end: '', available: false },
    sunday: { start: '', end: '', available: false }
  },
  note: 'Programările se fac prin telefon sau email. În situații de urgență, vă rog să contactați serviciile de urgență medicală.',
  emergencyNote: 'Pentru situații de criză psihologică, apelați 0800 080 200 (Telefonul Speranței) disponibil 24/7.'
};
